/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lesson_Confirmed_AtInputs */

const en_lesson_confirmed_at = /** @type {(inputs: Lesson_Confirmed_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmed at`)
};

const he_lesson_confirmed_at = /** @type {(inputs: Lesson_Confirmed_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אושר בתאריך`)
};

/**
* | output |
* | --- |
* | "Confirmed at" |
*
* @param {Lesson_Confirmed_AtInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const lesson_confirmed_at = /** @type {((inputs?: Lesson_Confirmed_AtInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lesson_Confirmed_AtInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lesson_confirmed_at(inputs)
	return he_lesson_confirmed_at(inputs)
});